import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "13",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12.826 4.01 8.853.169A.6.6 0 0 0 8.435 0H.591A.58.58 0 0 0 0 .571V15.43A.58.58 0 0 0 .59 16h11.82a.58.58 0 0 0 .59-.571V4.416a.56.56 0 0 0-.174-.405m-1.189.669H8.162V1.318zm.034 10.035H1.33V1.286h5.576v3.857c0 .199.082.39.227.53a.8.8 0 0 0 .549.22h3.989z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      stroke: "currentColor",
      "stroke-width": ".5",
      d: "M4.982 10.224a.437.437 0 1 0-.636.6l.989 1.046c.08.083.187.13.299.13s.22-.047.299-.13L9.468 8.13a.435.435 0 0 0-.632-.597l-3.2 3.385z"
    }, null, -1)
  ]))]))
}
export default { render: render }